import { Check, X } from "lucide-react";

const RULES = [
  ["At least 8 characters", (p) => p.length >= 8],
  ["One uppercase letter", (p) => /[A-Z]/.test(p)],
  ["One number", (p) => /\d/.test(p)],
  ["One special character", (p) => /[^A-Za-z0-9]/.test(p)],
];

export function passwordScore(password = "") {
  const met = RULES.filter(([, test]) => test(password)).length;
  const label = ["Too weak", "Weak", "Fair", "Good", "Strong"][met];
  const color = ["#64748B", "#EF4444", "#F59E0B", "#3B82F6", "#22C55E"][met];
  return { met, total: RULES.length, label, color };
}

export const PasswordStrength = ({ password = "", dark = false }) => {
  const { met, total, label, color } = passwordScore(password);
  if (!password) return null;
  return (
    <div className="mt-2" data-testid="password-strength">
      <div className="flex gap-1">
        {RULES.map((_, i) => (
          <span
            key={i}
            className="h-1 flex-1 transition-colors duration-200"
            style={{ background: i < met ? color : dark ? "rgba(255,255,255,0.12)" : "rgba(0,0,0,0.1)" }}
          />
        ))}
      </div>
      <div className="flex items-center justify-between mt-1.5">
        <span className="text-[11px] font-medium" style={{ color }} data-testid="password-strength-label">
          {label}
        </span>
        <span className="text-[10.5px]" style={{ color: dark ? "rgba(234,240,247,0.4)" : undefined }}>
          {met}/{total} rules met
        </span>
      </div>
      <ul className="mt-1.5 grid grid-cols-2 gap-x-3 gap-y-0.5">
        {RULES.map(([text, test]) => {
          const ok = test(password);
          return (
            <li
              key={text}
              className="flex items-center gap-1 text-[10.5px]"
              style={{ color: ok ? "#22C55E" : dark ? "rgba(234,240,247,0.4)" : "rgba(0,0,0,0.45)" }}
            >
              {ok ? <Check className="w-3 h-3 shrink-0" /> : <X className="w-3 h-3 shrink-0" />}
              {text}
            </li>
          );
        })}
      </ul>
    </div>
  );
};
